import { IMaterialId } from '@/services/material';
import messages from '../messages';

export default function(
  this: any,
  id: IMaterialId,
  name: string,
): Promise<boolean> {
  const { commit, dispatch, state } = (this as any).$store;

  return new Promise(resolve => {
    commit('dialog/CREATE', {
      title: 'Delete material?',
      content: this.$formatMessage(
        messages.MATERIAL_DELETE_ASK,
        name,
      ),
      compact: true,
      buttons: [{
        text: 'No, don\'t delete',
        click: (dialog: any) => {
          resolve(false);
          dialog.close();
        },
      }, {
        text: 'Yes, delete',
        click: (dialog: any) => {
          const moduleName = state.materials ? 'materials' : 'material';
          commit('loader/ADD', {
            title: this.$formatMessage(
              messages.MATERIAL_DELETE_CONFIRM,
              name,
            ),
            promise: dispatch(`${moduleName}/remove`, id)
              .then(() => {
                resolve(true);
                dialog.close();
              }, () => {
                commit('dialog/CREATE', {
                  title: 'Error :(',
                  content: messages.ERROR_MATERIAL_DELETE,
                  compact: true,
                  buttons: [{
                    text: 'Close',
                    click: (subDialog: any) => subDialog.close(),
                  }],
                });
              }),
          });
        },
      }],
    });
  });
}
